import { Container, DialogActions, DialogTitle, Grid } from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import Chip from "../../../components/basics/Chip";
import SelectErp from "../../../components/basics/SelectErp";
import Btn from "../../../components/buttons/Btn";
import Card from "../../../components/cards/Card";
import { TemplateEmailsContext } from "../contexts/TemplateEmailsContext";
import useTemplatesEmailsController from "../controller/TemplatesEmailsController";
import {
  Header,
  Body,
  CustomDialog,
  DialogContentStyled,
  StyledDialog,
} from "../styles/Modals";
import { DivHeandleEmail } from "../styles/ContentForm";
import TextField from "../../../components/basics/TextFieldErp";
import EditorTiny from "../../../components/inputs/EditorTiny";
import { QueryParamsContext } from "../../../context/QueryParamsContext";

const ModalHeaders = ({ open, setContent, setOpen }) => {
  const {
    header,
    setHeader,
    headersList,
    setHeadersList,
    headerEditor,
    setHeaderEditor,
    descriptionHeader,
    setDescriptionHeader,
    setHeaderHeandle,
  } = useContext(TemplateEmailsContext);

  const [disabledEditor, setDisabledEditor] = useState(true);

  const { queryParams } = useContext(QueryParamsContext);

  const { initHeandleInputs, store, show, update, destroy, selectedItem } =
    useTemplatesEmailsController();

  useEffect(() => {
    if (queryParams.empresa_cnpj) initHeandleInputs("header");
  }, [initHeandleInputs, queryParams.empresa_cnpj]);

  useEffect(() => {
    setDescriptionHeader("");
    if (header?.value === "") {
      setDisabledEditor(false);
      setHeaderEditor("");
    } else {
      setDisabledEditor(true);
    }

    if (header?.value) {
      show("headers");
    }
  }, [header, show, setHeaderEditor, setDescriptionHeader]);

  const handleClose = () => {
    setContent(null);
    setOpen(false);
  };

  const clearStates = () => {
    setHeader("");
    setHeaderEditor("");
    setHeadersList(null);
    setDescriptionHeader("");
    setDisabledEditor(true);
  };

  const handleSave = async () => {
    if (header?.value === "") {
      await store("headers");
    } else {
      await update("headers");
      selectedItem("header");
    }
    clearStates();
    handleClose();
  };

  const handleDestroy = async () => {
    await destroy("headers");
    setHeaderHeandle("");
    clearStates();
    initHeandleInputs("header");
  };

  return (
    <CustomDialog
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      fullWidth={true}
      disableEnforceFocus={true}
    >
      <StyledDialog>
        <DialogTitle id="dialog-title">
          <Header>
            <Grid container align="center" justifyContent="center">
              <Chip
                bgcolor="primary"
                textcolor="white"
                label={"CONFIGURAÇÃO DE CABEÇALHO"}
              />
            </Grid>
          </Header>
        </DialogTitle>
        <DialogContentStyled>
          <Body>
            <Container maxWidth="lg">
              <Card fullWidth={true} line="left">
                <Grid item container xs={12} spacing={1}>
                  <Grid item xs>
                    <SelectErp
                      error={false}
                      loading={false}
                      label="Cabeçalho"
                      value={header}
                      setValue={setHeader}
                      optionsList={headersList}
                      descriptionField="label"
                      variant="filled"
                    />
                  </Grid>
                  <Grid item xs>
                    {(header?.value === "" || !disabledEditor) && (
                      <TextField
                        label="Descrição"
                        variant="filled"
                        type="text"
                        size="small"
                        setValue={setDescriptionHeader}
                        value={descriptionHeader}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item container xs={12} spacing={1}>
                  {(header?.value || header?.value === "") && (
                    <DivHeandleEmail>
                      <EditorTiny
                        value={headerEditor}
                        setValue={setHeaderEditor}
                        disabled={disabledEditor}
                      />
                    </DivHeandleEmail>
                  )}
                </Grid>
              </Card>
            </Container>
          </Body>
        </DialogContentStyled>
        <DialogActions>
          <Grid item container xs spacing={1}>
            <Grid item container xs />
            {header?.value && disabledEditor && (
              <Grid item container xs={2}>
                <Btn
                  onClick={() => {
                    selectedItem("header");
                    clearStates();
                    handleClose();
                  }}
                  bgcolor="darkgreen"
                  label="Selecionar"
                  hovercolor="blue"
                  fullWidth={true}
                />
              </Grid>
            )}
            {header?.value && header?.access === "private" && disabledEditor && (
              <Grid item container xs={1}>
                <Btn
                  onClick={() => setDisabledEditor(false)}
                  bgcolor="orange"
                  label="Editar"
                  hovercolor="blue"
                />
              </Grid>
            )}
            {(header?.value || header?.value === "") &&
              descriptionHeader &&
              !disabledEditor &&
              headerEditor && (
                <Grid item container xs={3}>
                  <Btn
                    onClick={handleSave}
                    bgcolor="darkgreen"
                    label="Salvar e Selecionar"
                    hovercolor="blue"
                    fullWidth={true}
                  />
                </Grid>
              )}
            {(header?.value || header?.value !== "") &&
              header?.access === "private" &&
              !disabledEditor && (
                <Grid item container xs={1}>
                  <Btn
                    onClick={handleDestroy}
                    bgcolor="darkred"
                    label="Excluir"
                    hovercolor="blue"
                  />
                </Grid>
              )}
            <Grid item container xs={1}>
              <Btn
                onClick={handleClose}
                bgcolor="grey"
                label="Cancelar"
                hovercolor="blue"
              />
            </Grid>
          </Grid>
        </DialogActions>
      </StyledDialog>
    </CustomDialog>
  );
};

export default ModalHeaders;
